import React, { useState, useMemo } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData, categories }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    type_categorie: '',
    private: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const mainCategories = useMemo(
    () =>
      (categories || []).filter(
        (c) => c.type_categorie === null && (c.issubcategorie === 0 || c.issubcategorie == null)
      ),
    [categories]
  );

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : name === 'type_categorie' ? value : value,
    });
  };

  const resetForm = () => {
    setFormData({ nom: '', type_categorie: '', private: true, user_id: user?.id });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...formData,
      type_categorie: formData.type_categorie || null,
      private: !formData.private,
    };

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/categories`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || 'La sous-catégorie a été ajoutée avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        console.error("Erreur lors de l'envoi du formulaire", error);
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue. Veuillez réessayer.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter une sous-catégorie"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-subcategory-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-subcategory-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-sub-nom" className="duo-form-label">
            Nom de la sous-catégorie *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-sub-nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-sub-parent" className="duo-form-label">
            Catégorie parente *
          </label>
          <select
            id="add-sub-parent"
            name="type_categorie"
            className="duo-select"
            value={formData.type_categorie}
            onChange={handleChange}
          >
            <option value="">Sélectionner une catégorie</option>
            {mainCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nom}
              </option>
            ))}
          </select>
          {errors.type_categorie && (
            <p className="text-danger small mt-1 mb-0">{errors.type_categorie[0]}</p>
          )}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="private"
              checked={formData.private}
              onChange={handleChange}
            />
            <span>
              Sous-catégorie active
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour la rendre inactive.
              </span>
            </span>
          </label>
          {errors.private && <p className="text-danger small mt-1 mb-0">{errors.private[0]}</p>}
        </div>
      </form>
    </DuoModal>
  );
}
